import { Component } from "react"
import RegistrationsPropTypes from "utils/prop_types"
import PropTypes from "prop-types"
import { centsToFormatted } from "utils/money"

class ValidationMessage extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <p className="error-alert alert mt-1">
        Amount must be between {this.getFormattedAmount(this.props.minAmountCents)} and{" "}
        {this.getFormattedAmount(this.props.maxAmountCents)}
      </p>
    )
  }

  getFormattedAmount(amountCents) {
    return centsToFormatted(amountCents, this.props.currency)
  }
}

ValidationMessage.propTypes = {
  currency: RegistrationsPropTypes.Currency.isRequired,
  maxAmountCents: PropTypes.number.isRequired,
  minAmountCents: PropTypes.number.isRequired
}

export default ValidationMessage
